{
  "consent.action-accept": "Zezwól",
  "consent.action-reject": "Odmów",
  "consent.description": "Udzielaj uprawnień tylko wtedy, gdy ufasz tej witrynie lub aplikacji. Nie musisz akceptować wszystkich uprawnień.",
  "consent.privacy-policy-label": "Polityka Prywatności",
  "consent.remember-label": "Zapamiętaj tę decyzję. Aplikacja nie będzie mogła prosić o dodatkowe uprawnienia bez Twojej zgody.",
  "consent.remember-tooltip": "zapamiętaj moją decyzję",
  "consent.requested-permissions-label": "Aplikacja żąda dostępu do następujących uprawnień:",
  "consent.terms-of-service-label": "Warunki świadczenia usług",
  "error.back-button": "Cofnij",
  "error.description": "Wystąpił błąd z następującym komunikatem:",
  "error.support-email-link": "Jeżeli problem nie ustępuje skontaktuj się z <a>{contactSupportEmail}</a>",
  "error.title": "Wystąpił błąd",
  "error.title-internal-server-error": "Wewnętrzny błąd serwera",
  "error.title-not-found": "404 - Nie odnaleziono takiej strony",
  "identities.messages.1010001": "Zaloguj się",
  "identities.messages.1010002": "Zaloguj się za pomocą {provider}",
  "identities.messages.1010003": "Potwierdź tę czynność, potwierdzając, że to Ty.",
  "identities.messages.1010004": "Ukończ drugi etap uwierzytelnienia.",
  "identities.messages.1010005": "Zweryifkuj",
  "identities.messages.1010006": "Kod autentykacyjny",
  "identities.messages.1010007": "Zapasowe kody odzyskiwania",
  "identities.messages.1010008": "Kontynuuj z kluczem sprzętowym",
  "identities.messages.1010009": "Kontynuuj",
  "identities.messages.1010010": "Kontynuuj",
  "identities.messages.1010011": "Kontynuuj za pomocą klucza bezpieczeństwa",
  "identities.messages.1010012": "Przygotuj swoje urządzenie WebAuthn (np. klucz bezpieczeństwa, czytnik biometryczny, ...) a następnie kliknij kontynuuj.",
  "identities.messages.1010013": "Kontynuuj",
  "identities.messages.1010014": "Email zawierający kod został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i spróbuj zalogować się ponownie.",
  "identities.messages.1010015": "Zaloguj się kodem",
  "identities.messages.1040001": "Zarejestruj się",
  "identities.messages.1040002": "Zarejestruj się za pomocą {provider}",
  "identities.messages.1040003": "Kontynuuj",
  "identities.messages.1040004": "Zarejestruj się kluczem bezpieczeństwa",
  "identities.messages.1040005": "Email zawierający kod został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i ponów rejestrację.",
  "identities.messages.1040006": "Zarejestruj się kodem",
  "identities.messages.1050001": "Twoje zmiany zostały zapisane!",
  "identities.messages.1050002": "Połącz {provider}",
  "identities.messages.1050003": "Odłącz {provider}",
  "identities.messages.1050004": "Odłącz Apikację Autentykator TOTP",
  "identities.messages.1050005": "Kod QR aplikacji Autentykator",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Pokaż zapasowe kody odzyskiwania",
  "identities.messages.1050008": "Wygeneruj nowe zapasowe kody odzyskiwania",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "To są Twoje zapasowe kody odzyskiwania. Trzymaj je w bezpiecznym miejscu!",
  "identities.messages.1050011": "Potwierdź zapasowe kody odzyskiwania",
  "identities.messages.1050012": "Dodaj klucz bezpieczeństwa",
  "identities.messages.1050013": "Nazwa klucza bezpieczeństwa",
  "identities.messages.1050014": "<del>Wykorzystany</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Wyłącz tą metodę",
  "identities.messages.1050017": "To jest sekret twojej aplikacji autentykator. Użyj go jeżeli nie możesz zeskanować kodu QR.",
  "identities.messages.1050018": "Usuń klucz bezpieczeństwa \"{display_name}\"",
  "identities.messages.1060001": "Pomyślnie odzyskałeś swoje konto. Proszę zmień swoję hasło lub ustanowić alternatywną methodę logowania (np. logowanie zewnętrzne) w ciągu najbliższych {privileged_session_expires_at_unix_until_minutes} minut.",
  "identities.messages.1060002": "Email zawierający link odzyskiwania został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i upewnij się że używasz adresu użytego do rejestracji.",
  "identities.messages.1060003": "Email zawierający kod odzyskiwania został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i upewnij się że używasz adresu użytego do rejestracji.",
  "identities.messages.1070001": "Hasło",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Zapisz",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Wyślij",
  "identities.messages.1070006": "Zweryfikuj kod",
  "identities.messages.1070007": "Email",
  "identities.messages.1070008": "Wyślij kod ponownie",
  "identities.messages.1070009": "Kontynuuj",
  "identities.messages.1070010": "Kod odzyskiwania",
  "identities.messages.1070011": "Kod weryfikacyjny",
  "identities.messages.1070012": "Kod rejestracji",
  "identities.messages.1070013": "Kod logowania",
  "identities.messages.1080001": "Email zawierający link weryfikacyjny został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i upewnij się że używasz adresu użytego do rejestracji.",
  "identities.messages.1080002": "Poprawnie zweryfikowano adres email.",
  "identities.messages.1080003": "Email zawierający kod weryfikacyjny został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i upewnij się że używasz adresu użytego do rejestracji.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Brakuje pola {property}.",
  "identities.messages.4000003": "długość musi być >= {min_length}, otrzymano {actual_length}",
  "identities.messages.4000004": "nie pasuje do wzoru \"{pattern}\"",
  "identities.messages.4000005": "Hasło nie może być użyte ponieważ {reason}.",
  "identities.messages.4000006": "Podane poświadczenia są nieprawidłowe, sprawdź czy nie ma literówek w twoim haśle, nazwie użytkownika, adresie email lub numerze telefonu.",
  "identities.messages.4000007": "Istnieje już konto o takim samym identyfikatorze (email, telefon, nazwa użytkownika, ...).",
  "identities.messages.4000008": "Podany kod autentykacyjny jest nieprawidłowy, spróbuj ponownie.",
  "identities.messages.4000009": "Nie odnaleziono żadnych identyfikatorów logowania. Czy zapomniałeś je ustawić? Może też być to spowodowane nieprawidłową konfiguracją serwera.",
  "identities.messages.4000010": "Konto nie jest jeszcze aktywne. Czy zapomniałeś/łaś zweryfikować swój adres email?",
  "identities.messages.4000011": "Nie ustanowiono urządzenia TOTP.",
  "identities.messages.4000012": "Ten kod odzyskiwania jest już wykorzystany.",
  "identities.messages.4000013": "Nie ustanowiono urządzenia WebAuthn.",
  "identities.messages.4000014": "Nie ustanowiono kodów odzyskiwania.",
  "identities.messages.4000015": "To konto nie istnieje lub nie zezwala na logowanie kluczem odzyskiwania.",
  "identities.messages.4000016": "Kod odzyskiwania jest nieprawidłowy.",
  "identities.messages.4000017": "długośc musi być <= {max_length}, otrzymano {actual_length}",
  "identities.messages.4000018": "musi być >= {minimum} otrzymano {actual}",
  "identities.messages.4000019": "musi być > {minimum} otrzymano {actual}",
  "identities.messages.4000020": "musi być <= {maximum} otrzymano {actual}",
  "identities.messages.4000021": "musi być < {maximum} otrzymano {actual}",
  "identities.messages.4000022": "{actual} nie jest wielokrotnością {base}",
  "identities.messages.4000023": "maksymalnie {max_items} wpisów, otrzymano {actual_items} wpisów",
  "identities.messages.4000024": "minimum {min_items} wpisów, otrzymano {actual_items} wpisów",
  "identities.messages.4000025": "wpisów w indeksie {index_a} i {index_b} są takie same",
  "identities.messages.4000026": "spodziewano {allowed_types_list}, otrzymano {actual_type}",
  "identities.messages.4000027": "Istnieje już konto o takim samym identyfikatorze (email, telefon, nazwa użytkownika, ...). Zaloguj się do swojego konta i połącz swój profil zewnętrzny na stronie ustawień.",
  "identities.messages.4000028": "Próbowano się zalogować za pomocą {credential_identifier_hint} który jest już używany przez inne konto. Możesz się zalogować za pomocą {available_credential_types_list}. Możesz się zalogować za pomocą następujących zewnętrznch dostawców logowania: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "musi być równe stałej {expected}",
  "identities.messages.4000030": "const nie powiodła się",
  "identities.messages.4000031": "Hasło nie może być użytę ponieważ jest zbyt podobne do identyfikatora.",
  "identities.messages.4000032": "Hasło musi być długie na co najmniej {min_length} znaków, wprowadzono {actual_length} znaków.",
  "identities.messages.4000033": "Hasło musi być nie dłuższe niż {max_length} znaków, wprowadzono {actual_length} znaków.",
  "identities.messages.4000034": "Hasło wyciekło w wyniku naruszenia danych i nie może być użyte.",
  "identities.messages.4000035": "To konto nie istnieje lub nie pozwala na logowanie kodem.",
  "identities.messages.4000036": "Podane atrybuty nie odpowiadają atrybutom wcześniej powiązanym z tym procesem.",
  "identities.messages.4010001": "Proces logowania wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4010002": "Nie odnaleziono strategii do logowania. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010003": "Nie odnaleziono strategii do rejestracji. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010004": "Nie odnaleziono strategii do aktualizacji ustawień. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010005": "Nie odnaleziono strategii do odzyskiwania konta. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010006": "Nie odnaleziono strategii do weryfikacj konta. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010007": "Żądanie zostało poprawnie zakończone i nie może być ponowione.",
  "identities.messages.4010008": "Kod logowania jest niepoprawny lub został wykorzystany. Spróbuj ponownie.",
  "identities.messages.4040001": "Proces rejestracji wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4040002": "Żądanie zostało poprawnie zakończone i nie może być ponowione.",
  "identities.messages.4040003": "Kod rejestracji jest niepoprawny lub został wykorzystany. Spróbuj ponownie.",
  "identities.messages.4050001": "Proces ustawień wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4060001": "Żądanie zostało poprawnie zakończone i nie może być ponowione.",
  "identities.messages.4060002": "Proces odzyskiwania jest niepoprawny i musi zostać ponowiony.",
  "identities.messages.4060004": "Token odzyskiwania jest niepoprawny lub został wykorzystany. Proszę ponowić proces.",
  "identities.messages.4060005": "Proces odzyskiwania wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4060006": "Kod odzyskiwania jest nieprawidłowy lub został wykorzystany. Spróbuj ponownie.",
  "identities.messages.4070001": "Token weryfikacyjny jest nieprawidłowy lub został wykorzystany. Proszę ponowić proces.",
  "identities.messages.4070002": "Żądanie zostało poprawnie zakończone i nie może być ponowione.",
  "identities.messages.4070003": "Proces weryfikacyjny jest nieprawidłowy i musi zostać ponowiony.",
  "identities.messages.4070005": "Proces weryfikacyjny wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4070006": "Kod weryfikacyjny jest nieprawidłowy lub został wykorzystany. Spróbuj ponownie.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "Zapomniałeś/łaś hasła?",
  "login.logged-in-as-label": "Jesteś zalogowany jako:",
  "login.logout-button": "Wyloguj",
  "login.logout-label": "Coś nie działa?",
  "login.registration-button": "Zarejestruj się",
  "login.registration-label": "Nie posiadasz konta?",
  "login.subtitle-oauth2": "Do autentykacji {clientName}",
  "login.title": "Zaloguj się",
  "login.title-aal2": "Uwierzytelnianie dwuskładnikowe",
  "login.subtitle-aal2": "Wybierz sposób, aby zakończyć uwierzytelnianie dwuskładnikowe",
  "login.code.subtitle": "Kod weryfikacyjny zostanie wysłany e-mailem",
  "login.webauthn.subtitle": "Proszę przygotować urządzenie WebAuthN",
  "login.totp.subtitle": "Proszę wprowadzić kod wygenerowany przez Twoją aplikację uwierzytelniającą",
  "login.lookup_secret.subtitle": "Proszę wprowadzić jeden z Twoich 8-cyfrowych kodów odzyskiwania zapasowego",
  "login.title-refresh": "Potwierdź że to Ty",
  "login.2fa.go-back": "Coś nie działa?",
  "login.2fa.go-back.link": "Wróć",
  "login.2fa.method.go-back": "Wybierz inną metodę",
  "logout.accept-button": "Tak",
  "logout.reject-button": "Nie",
  "logout.title": "Czy chcesz się wylogować?",
  "recovery.login-button": "Zaloguj się",
  "recovery.login-label": "Pamiętasz dane logowania?",
  "recovery.title": "Odzyskaj konto",
  "registration.login-button": "Zaloguj się",
  "registration.login-label": "Posiadasz już konto?",
  "registration.subtitle-oauth2": "Do autentykacji {clientName}",
  "registration.title": "Zarejestruj konto",
  "settings.navigation-back-button": "Cofnij",
  "settings.navigation-backup-codes": "Kody zapasowe 2FA",
  "settings.navigation-logout": "Wyloguj",
  "settings.navigation-oidc": "Zewnętrzne logowanie",
  "settings.navigation-password": "Hasło",
  "settings.navigation-profile": "Profil",
  "settings.navigation-totp": "Aplikacja Autentykator",
  "settings.navigation-webauthn": "Tokeny Sprzętowe",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Tutaj możesz zarządzać ustawieniami związanymi z Twoim kontem. Miej na uwadze że niektóre akcje mogą wymagać ponownej uwierzytelnienia.",
  "settings.title": "Ustawienia Konta",
  "verification.registration-button": "Zarejestruj się",
  "verification.registration-label": "Nie posiadasz konta?",
  "verification.title": "Zweryfikuj konto",
  "verification.back-button": "Cofnij",
  "two-step.code.description": "Kod weryfikacyjny zostanie wysłany na Twój adres email.",
  "two-step.code.title": "Kod email",
  "two-step.passkey.description": "Użyj swojego urządzenia lub funkcji rozpoznawania twarzy na swoim urządzeniu.",
  "two-step.passkey.title": "Klucz dostępu (zalecany)",
  "two-step.password.description": "Wprowadź hasło powiązane z twoim kontem",
  "two-step.password.title": "Hasło",
  "two-step.webauthn.title": "Klucz bezpieczeństwa",
  "two-step.webauthn.description": "Użyj swojego klucza bezpieczeństwa do uwierzytelnienia",
  "two-step.totp.title": "Użyj swojej aplikacji uwierzytelniającej (TOTP)",
  "two-step.totp.description": "Użyj 6-cyfrowego jednorazowego kodu z Twojej aplikacji uwierzytelniającej",
  "two-step.lookup_secret.title": "Kod odzyskiwania zapasowego",
  "two-step.lookup_secret.description": "Użyj jednego z Twoich 8-cyfrowych kodów zapasowych, aby się uwierzytelnić",
  "identities.messages.1010016": "",
  "identities.messages.1010017": "",
  "identities.messages.1010018": "",
  "identities.messages.1010019": "",
  "identities.messages.1010020": "",
  "identities.messages.1010021": "",
  "identities.messages.1010022": "",
  "identities.messages.1010023": "",
  "identities.messages.1040007": "",
  "identities.messages.1040008": "",
  "identities.messages.1040009": "",
  "identities.messages.1050019": "",
  "identities.messages.1050020": "",
  "identities.messages.1070014": "",
  "identities.messages.1070015": "",
  "identities.messages.4000037": "",
  "identities.messages.4000038": "",
  "identities.messages.4010009": "",
  "identities.messages.4010010": "",
  "login.cancel-button": "",
  "login.cancel-label": "",
  "input.placeholder": "",
  "card.header.description.login": "",
  "card.header.description.registration": "",
  "card.header.parts.code": "",
  "card.header.parts.identifier-first": "",
  "card.header.parts.oidc": "",
  "card.header.parts.passkey": "",
  "card.header.parts.password.login": "",
  "card.header.parts.password.registration": "",
  "card.header.parts.webauthn": "",
  "forms.label.forgot-password": "",
  "login.subtitle": "",
  "login.subtitle-refresh": "",
  "misc.or": "",
  "recovery.subtitle": "",
  "registration.subtitle": "",
  "settings.subtitle": "",
  "verification.subtitle": "",
  "settings.totp.info.linked": "Aktualnie masz podłączoną aplikację uwierzytelniającą.",
  "settings.totp.info.not-linked": "Aby włączyć, zeskanuj kod QR za pomocą swojego uwierzytelniającego i wprowadź kod.",
  "settings.totp.title": "",
  "settings.totp.description": "Dodaj aplikację do uwierzytelniania TOTP do swojego konta, aby poprawić bezpieczeństwo swojego konta. Popularne aplikacje uwierzytelniające to LastPass i Google Authenticator.",
  "settings.lookup_secret.description": "",
  "settings.lookup_secret.title": "",
  "settings.navigation.title": "",
  "settings.oidc.description": "",
  "settings.oidc.info": "",
  "settings.oidc.title": "",
  "settings.passkey.description": "",
  "settings.passkey.info": "",
  "settings.passkey.title": "",
  "settings.password.description": "",
  "settings.password.title": "",
  "settings.profile.description": "",
  "settings.profile.title": "",
  "settings.title-lookup-secret": "",
  "settings.title-navigation": "",
  "settings.title-oidc": "",
  "settings.title-passkey": "",
  "settings.title-password": "",
  "settings.title-profile": "",
  "settings.title-totp": "",
  "settings.title-webauthn": "",
  "settings.webauthn.description": "",
  "settings.webauthn.info": "",
  "settings.webauthn.title": "",
  "card.footer.select-another-method": "",
  "account-linking.title": "",
  "property.code": "",
  "property.email": "",
  "property.password": "",
  "property.phone": "",
  "property.username": "",
  "property.identifier": "",
  "consent.title": "Autoryzuj {party}",
  "consent.subtitle": "Aplikacja trzeciej strony chce uzyskać dostęp do informacji powiązanych z Twoim kontem {identifier}.",
  "consent.scope.openid.title": "Tożsamość",
  "consent.scope.openid.description": "Pozwala aplikacji zweryfikować Twoją tożsamość. Jest to wymagane do uwierzytelniania i zapewnienia zaufanej sesji logowania.",
  "consent.scope.offline_access.title": "Dostęp offline",
  "consent.scope.offline_access.description": "Pozwala aplikacji utrzymać Twoje logowanie, nawet gdy nie korzystasz z niej aktywnie.",
  "consent.scope.profile.title": "Informacje profilowe",
  "consent.scope.profile.description": "Pozwala na dostęp do podstawowych danych profilowych, w tym nazwy użytkownika, imienia i nazwiska.",
  "consent.scope.email.title": "Adres e-mail",
  "consent.scope.email.description": "Pobierz swój adres e-mail oraz status jego weryfikacji.",
  "consent.scope.address.title": "Adres fizyczny",
  "consent.scope.address.description": "Dostęp do Twojego adresu pocztowego.",
  "consent.scope.phone.title": "Numer telefonu",
  "consent.scope.phone.description": "Pobierz swój numer telefonu oraz status jego weryfikacji.",
  "error.action.go-back": "",
  "error.footer.copy": "",
  "error.footer.text": "",
  "error.title.what-can-i-do": "",
  "error.title.what-happened": "",
  "error.instructions": ""
}
